// Shared react-data-table-component styling for the report screens.
//
// Most reports are plain bootstrap tables, so the browser styles their header
// for us. A DataTable is not a `.table`, so it gets none of that and ends up
// looking like a different product. These values are the computed header of a
// plain report (Loan report is the reference), traced through the cascade:
//
//   bootstrap.min.css  .table th          padding .75rem
//                      .table-bordered th border 1px solid #dee2e6 !important
//   main.css           .table thead th    padding-top/bottom .5rem
//                      .table th          font-weight 400, text-transform uppercase
//                      .table td,.table th font-size 12px
//   theme2.css         .table th          color #2c2945   <- loads last, wins
//   index.css          .sticky-head-tint  background-color #c9cdcc
//
// The colour is the easy one to get wrong: main.css says #9aa0ac, but theme2.css
// is imported after it and overrides to the darker #2c2945.
const REPORT_HEAD_BG = "#c9cdcc";
const REPORT_BORDER = "#dee2e6";

export const reportTableStyles = {
  headRow: {
    style: {
      backgroundColor: REPORT_HEAD_BG,
      minHeight: "36px",
      borderBottomWidth: "1px",
      borderBottomColor: REPORT_BORDER,
      borderBottomStyle: "solid",
    },
  },
  headCells: {
    style: {
      backgroundColor: REPORT_HEAD_BG,
      color: "#2c2945",
      fontSize: "12px",
      fontWeight: 400,
      textTransform: "uppercase",
      paddingLeft: "12px",
      paddingRight: "12px",
      borderRight: `1px solid ${REPORT_BORDER}`,
    },
  },
};

export default reportTableStyles;
